class Comments {
  constructor() {
    this.formInit();
    this.commentForm();
    this.ratings();
  }
  formInit = () => {
    const labels = document.querySelectorAll(".js-form-label");
    labels.forEach((label) => {
      let input = label.querySelector("input");
      if (!input) {
        input = label.querySelector("textarea");
      }
      if (input.value != "") {
        label.classList.add("input");
      }
      input.addEventListener("animationstart", (e) => {
        if (e.animationName == "onAutoFillStart") {
          label.classList.add("active");
        }
      });
      input.addEventListener("focus", () => {
        labels.forEach((l) => {
          if (l != label) {
            l.classList.remove("active");
          }
        });
        label.classList.add("active");
      });
      input.addEventListener("input", (e) => {
        if (e.target.value != "") {
          label.classList.add("input");
        } else {
          label.classList.remove("input");
        }
      });
    });
  };

  ratings = () => {
    const wrapper = document.querySelector(".custom-rating");
    if (!wrapper) {
      return;
    }
    const selection = wrapper.querySelector("select");
    const stars = document.createElement("div");
    stars.classList.add("custom-stars");
    for (let i = 1; i < 6; i++) {
      let star = document.createElement("span");
      star.classList.add("custom-star");
      star.setAttribute("data-value", i);
      star.innerHTML = `<svg width="32" height="31" viewBox="0 0 32 31" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M15.9422 1.61804L19.201 11.6477L19.3133 11.9932H19.6766H30.2224L21.6906 18.1919L21.3968 18.4054L21.509 18.7509L24.7679 28.7806L16.2361 22.5819L15.9422 22.3684L15.6483 22.5819L7.11656 28.7806L10.3754 18.7509L10.4877 18.4054L10.1938 18.1919L1.66201 11.9932H12.2078H12.5711L12.6834 11.6477L15.9422 1.61804Z" stroke="#F3D66C"/>
</svg>
`;
      stars.appendChild(star);
    }
    wrapper.appendChild(stars);
    this.starListeners(selection);
  };

  starListeners = (selection) => {
    const stars = document.querySelectorAll(".custom-star");
    stars.forEach((star, index) => {
      star.addEventListener("click", () => {
        selection.value = star.getAttribute("data-value");
        stars.forEach((s, i) => {
          if (i <= index) {
            s.classList.add("active");
          } else {
            s.classList.remove("active");
          }
        });
      });
    });
  };

  commentForm = () => {
    const wrapper = document.querySelector(".js-post-comment");
    const form = wrapper.querySelector(".comment-form");
    form?.addEventListener("submit", (e) => {
      e.preventDefault();
      this.fetchData(e.target);
    });
  };

  fetchData = async (form) => {
    const wrapper = document.querySelector(".js-post-comment");
    let formData = new FormData(form);
    formData.append("action", "post_comment_ajax");
    const response = await fetch(ajaxurl, {
      method: "POST",
      body: formData,
    });
    const data = await response.json();
    wrapper.innerHTML = data.comment;
    this.formInit();
    this.commentForm();
    this.ratings();
  };
}

export default Comments;
